import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

export const AboutStripSection: React.FC = () => {
  return (
    <section
      className="spaq-about bg-white border-y border-[#DCE4EA] text-[#122331] py-8 sm:py-10"
      aria-labelledby="spaq-about-heading"
    >
      <div className="max-w-[1280px] mx-auto px-5 sm:px-8 lg:px-12 flex flex-col lg:flex-row lg:items-center justify-between gap-6 lg:gap-10">
        {/* Left Heading */}
        <h2
          id="spaq-about-heading"
          className="text-2xl sm:text-[26px] font-bold text-[#122331] shrink-0 tracking-tight"
        >
          現場の知見を、技術へ。
        </h2>

        {/* Center Narrative with Divider */}
        <div className="lg:border-l lg:border-[#DCE4EA] lg:pl-8 flex-1">
          <p className="text-sm text-[#526372] leading-relaxed max-w-2xl">
            エンジニアリングとソフトウェアで、よりよい電力の使い方を社会に実装していきます。
          </p>
        </div>

        {/* Right Link */}
        <Link
          to="/technology"
          className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#087C96] hover:text-[#23A6C4] hover:underline transition-colors shrink-0 group self-start lg:self-auto"
        >
          <span>技術と開発を見る</span>
          <ArrowRight
            size={16}
            className="transition-transform group-hover:translate-x-1"
            aria-hidden="true"
          />
        </Link>
      </div>
    </section>
  );
};
